import { Switch } from 'antd';
import React, { FC } from 'react';
import style from './index.module.scss';

type TOrgstructireListItemProps = {
  name: string;
  isAvailable: boolean;
  id: string;
  loading?: boolean;
  updateOrgstructure: (id: string, isAvailable: boolean) => void;
};

const OrgstructireListItem: FC<TOrgstructireListItemProps> = ({
  isAvailable,
  name,
  id,
  updateOrgstructure,
  loading,
}) => {
  return (
    <div className={style.container}>
      <p>{name}</p>
      <Switch value={isAvailable} onChange={() => updateOrgstructure(id, !isAvailable)} loading={loading} />
    </div>
  );
};

export default OrgstructireListItem;
